<template>
	<v-row justify="center" align="center" class="mb-3">
		<v-col cols="12" sm="10" md="8" lg="6" xl="4" class="px-0">
			<v-card
				class="d-flex flex-wrap justify-center align-center card px-0 py-5"
				elevation="5"
			>
				<v-col justify="center" align="center" class="pa-0" cols="4">
					<v-img
						:src="
							productInfo.image != ''
								? require(`../../assets/img/merch/${year}/${productInfo.image}`)
								: ''
						"
						contain
						width="125"
					>
						<template v-slot:placeholder>
							<v-row class="fill-height ma-0" align="center" justify="center">
								<v-progress-circular
									indeterminate
									color="grey lighten-2"
								></v-progress-circular>
							</v-row>
						</template>
					</v-img>
					<h5
						v-html="$t(replaceHyphen(productInfo.name))"
						class="mt-2 px-1"
					></h5>
					<h5
						v-html="$t('Currency', { amount: productInfo.price.toFixed(2) })"
					/>
				</v-col>

				<div class="d-flex flex-column flex-wrap ma-3">
					<v-row align="center" no-gutters>
						<v-btn
							color="red darken-2"
							class="btn-text white--text"
							@click="decrementQuantity()"
							x-large
						>
							<v-icon>mdi-minus</v-icon>
						</v-btn>
						<h1 class="px-8">
							{{ quantity }}
						</h1>
						<v-btn
							class="btn-text success"
							@click="incrementQuantity()"
							x-large
						>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-row>

					<v-row align="center" justify="center">
						<h1 v-html="$t('Currency', { amount: itemTotal.toFixed(2) })" />
					</v-row>
				</div>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { useOrderStore } from "../store/order";

export default {
	name: "ProductItem",
	data: () => ({
		quantity: 0,
		itemTotal: 0,
		year: new Date().getFullYear(),
	}),
	props: {
		productInfo: Object,
		cartInfo: Object,
	},
	mounted() {
		this.quantity =
			this.cartInfo[this.productInfo.id] != undefined
				? this.cartInfo[this.productInfo.id].quantity
				: 0;
	},
	setup() {
		const store = useOrderStore();

		return {
			store,
		};
	},
	watch: {
		quantity(newQuantity) {
			this.itemTotal = this.productInfo.price * newQuantity;

			// this.store.setNewOrderQuantity(this.productInfo.id, newQuantity);
			this.store.setNewOrderItems(this.productInfo.id, {
				name: this.productInfo.name,
				price: this.productInfo.price,
				quantity: newQuantity,
				total: this.itemTotal,
			});

			this.$emit(
				"quantityChanged",
				this.productInfo.id,
				newQuantity,
				this.itemTotal
			);
		},
	},
	methods: {
		replaceHyphen(value) {
			return value.replace("-", "&#8209;");
		},
		incrementQuantity() {
			this.quantity++;
			this.store.setItemQuantity(1);
		},
		decrementQuantity() {
			if (this.quantity !== 0) {
				this.quantity--;
				this.store.setItemQuantity(-1);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-size {
	size: 25px;
}
</style>
